import React from 'react';
import { Table } from 'semantic-ui-react';
import { isEmpty } from 'lodash';

const ListRow = (
  showProductSelection,
  isUpgradeAvailable,
  displayDealerConfirm,
  handleOpen,
  isAllOffersZero
) => (enrollment, index) => {
  const {
    currentlyEnrolled,
    dealerNo,
    groupName,
    productName,
    productType,
    incompleteEnrollment,
    name,
    rate,
    networkplus,
    networkplusRate,
    days,
    localLinkedFlag,
    closedFactoryExclusion,
  } = enrollment;

  const removeLocallyDealerHandler = e => {
    e.preventDefault();
    displayDealerConfirm(dealerNo);
  };

  const resendMailHandler = e => {
    e.preventDefault();
    handleOpen(incompleteEnrollment);
  };

  const showProductSelectionHandler = e => {
    e.preventDefault();
    const isRevise = incompleteEnrollment !== null;
    const isUpgrade = currentlyEnrolled === 'Y';
    showProductSelection(dealerNo, name, isRevise, isUpgrade);
  };

  const groupContent = isEmpty(groupName) || groupName === 'null'
    ? ''
    : `(part of group ${groupName})`;
  return (
    <Table.Row key={index}>
      <Table.Cell>
        <span className='dealer-details'>
          {' '}
          {`${dealerNo} - ${name} ${groupContent}`} <br />{' '}
          {currentlyEnrolled === 'Y' && (
            <div>
              {' '}
              {productName && productName}{' '}
              {!productName && `DealShield ${days}-Day`} {' at $'}{' '}
              {rate && parseInt(rate, 10)}{' '}
              {networkplus === 'TRUE'
                && ` ($${parseInt(networkplusRate, 10)} – Network Plus)`}{' '}
              <br />
            </div>
          )}{' '}
          {localLinkedFlag && incompleteEnrollment === null && (
            <div>
              Linked Locally{' | '}
              <button
                type='button'
                onClick={removeLocallyDealerHandler}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4183c4',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                }}
              >
                Remove Dealer
              </button>
            </div>
          )}
          {localLinkedFlag && incompleteEnrollment !== null && (
            <div>
              Linked Locally{' | '}
              <span> Remove Dealer feature unavailable due to pending offer </span>
            </div>
          )}
          {closedFactoryExclusion && <div>Closed Factory Exclusion</div>}
        </span>{' '}
      </Table.Cell>{' '}
      <Table.Cell className='enrollment-link'>
        <span>
          {' '}
          {currentlyEnrolled === 'Y'
            && isUpgradeAvailable(enrollment)
            && incompleteEnrollment === null && (
              <button
                type='button'
                onClick={showProductSelectionHandler}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4183c4',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                }}
              >
                Change Enrollment
              </button>
          )}
          {!(currentlyEnrolled === 'Y') && incompleteEnrollment === null && (
            <button
              type='button'
              onClick={showProductSelectionHandler}
              style={{
                background: 'none',
                border: 'none',
                color: '#4183c4',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit',
              }}
            >
              {' '}
              {' Start Enrollment '}{' '}
            </button>
          )}
          {incompleteEnrollment !== null && (
            <span>
              <button
                type='button'
                onClick={showProductSelectionHandler}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4183c4',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                }}
              >
                Single - Dealer Quote <br />
              </button>{' '}
              {`Sent ${incompleteEnrollment.sendAt} `} <br />
              <button
                type='button'
                onClick={resendMailHandler}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4183c4',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                }}
              >
                Resend the Offer <br />
              </button>{' '}
            </span>
          )}
          {currentlyEnrolled === 'N' && productType === null && (
            <span> {' Not eligible for DealShield products '} </span>
          )}{' '}
          {isAllOffersZero(enrollment) && incompleteEnrollment === null && (
            <span className='margin_spacing'>{' No eligible products available '}</span>
          )}{' '}
        </span>{' '}
      </Table.Cell>{' '}
    </Table.Row>
  );
};

export default ListRow;
